import type { ResponseErrorCode } from '@tabel/shared/errors';
import { contextHeaders } from './role';

/** Ошибка API: код, сообщение и requestId — «код ошибки» для команды (FR-032). */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: ResponseErrorCode | 'NETWORK',
    message: string,
    readonly requestId: string | null,
    readonly retryAfterSec?: number,
    /** `details` ответа: у `STALE_STATE` — `current`, новое состояние для показа рядом с формой (003). */
    readonly details?: unknown,
  ) {
    super(message);
  }
}

/** Сбой связи или сервера: то же действие можно повторить («Повторить» в тосте). Отказ по правам и статусу — нет. */
export function isTransient(err: unknown): boolean {
  return err instanceof ApiError && (err.code === 'NETWORK' || err.status >= 500);
}

/** Ошибки интерфейса — в серверный журнал (конституция, принцип II). */
export function reportClientError(screen: string, action: string, err: unknown): void {
  const e = err instanceof Error ? err : new Error(String(err));
  const body = {
    requestId: err instanceof ApiError ? (err.requestId ?? undefined) : undefined,
    screen: screen.slice(0, 100),
    action: action.slice(0, 200),
    message: e.message.slice(0, 2000),
    stack: e.stack?.slice(0, 5000),
  };
  void fetch('/api/client-errors', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...contextHeaders() },
    body: JSON.stringify(body),
  }).catch(() => {});
}
